export default __webpack_public_path__ + "static/media/downCaret.d756f606.svg";